<svg
  width="24px"
  height="25px"
  viewBox="0 0 24 25"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
>
  <!-- Generator: sketchtool 63.1 (101010) - https://sketch.com -->
  <title>CF0D5BC6-6FD9-441E-8FF9-39F918EEDC12</title>
  <desc>Created with sketchtool.</desc>
  <g
    id="Page-1"
    stroke="none"
    stroke-width="1"
    fill="none"
    fill-rule="evenodd"
  >
    <g
      id="1_Home"
      transform="translate(-121.000000, -106.000000)"
    >
      <g
        id="Tabs"
        transform="translate(118.000000, 106.000000)"
      >
        <g
          id="shutterstock_1487489126-[Converted]"
          transform="translate(3.000000, 0.000000)"
        >
          <polygon
            id="Path-6"
            fill="#FFFFFF"
            points="0.540439453 10.5607227 2.06540039 12.22 12.22 3.84325195 22.4541992 12.5187207 23.9225391 10.5607227 12.22 0.477216797"
          ></polygon>
          <polygon
            id="Path-7"
            fill="#FFFFFF"
            points="3.83804688 11.4998047 12.22 4.64325195 20.761 11.8324219 20.761 24.0591406 3.83804688 24.0591406"
          ></polygon>
          <polygon
            id="Path"
            fill="#8694A4"
            fill-rule="nonzero"
            points="10 13.5698162 11.3653958 13.5698162 13.3854793 13.5698162 14.7508751 13.5698162 14.7508751 24.5225569 10 24.5225569 10 14.6275418"
          ></polygon>
        </g>
      </g>
    </g>
  </g>
</svg>
